import { Trans } from '@lingui/react';
import React from 'react';
import { useBreakpoint, Nav, Button } from '@landr/maestro';
import { useNavBarContext } from '../../../../../../contexts/NavBarProvider/NavBarContext.es.js';

var NavBarAuth = function NavBarAuth() {
  var _useNavBarContext = useNavBarContext(),
    onLogin = _useNavBarContext.onLogin;
  var isSmallMobile = useBreakpoint('sm');
  var handleOnLogin = function handleOnLogin() {
    return onLogin === null || onLogin === void 0 ? void 0 : onLogin(false);
  };
  var handleOnSignUp = function handleOnSignUp() {
    return onLogin === null || onLogin === void 0 ? void 0 : onLogin(true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, !isSmallMobile && /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    isRounded: true,
    variant: "ghost",
    kind: "solid",
    onClick: handleOnLogin
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Log in"
  }))), /*#__PURE__*/React.createElement(Nav.Item, null, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    isRounded: true,
    variant: "primary",
    kind: "solid",
    onClick: handleOnSignUp
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Sign up"
  }))));
};

export { NavBarAuth };
